export default __webpack_public_path__ + "static/media/Scenery10.8499b756.jpg";